module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.work_hours')))]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away',
        onShow: function () { return _vm.isDateIntervalChanged; }
      }),
      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
    }],
    staticClass: "is-number",
    class: {
      'is-number--calculated': _vm.isDateIntervalChanged
    },
    attrs: {
      "content": _vm.tooltipContent
    }
  }, [(_vm.isDateIntervalChanged) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.getUserHoursOverview.actual_total_hours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.diffTotalHoursForPeriod))
  }, [_vm._v("\n      " + _vm._s(_vm.diffTotalHoursForPeriod) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Med børn")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away',
        onShow: function () { return _vm.isDateIntervalChanged; }
      }),
      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
    }],
    staticClass: "is-number",
    class: {
      'is-number--calculated': _vm.isDateIntervalChanged
    },
    attrs: {
      "content": _vm.createTooltip(_vm.assignedHoursWithKids)
    }
  }, [(_vm.isDateIntervalChanged) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedHoursWithKidsInPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.userActualWithKids))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.diffHoursWithKidsForPeriod))
  }, [_vm._v(_vm._s(_vm.diffHoursWithKidsForPeriod))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Uden børn")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away',
        onShow: function () { return _vm.isDateIntervalChanged; }
      }),
      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
    }],
    staticClass: "is-number",
    class: {
      'is-number--calculated': _vm.isDateIntervalChanged
    },
    attrs: {
      "content": _vm.createTooltip(_vm.assignedHoursWithoutKids)
    }
  }, [(_vm.isDateIntervalChanged) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedHoursWithoutKidsInPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.userActualWithoutKids))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.diffHoursWithoutKidsForPeriod))
  }, [_vm._v(_vm._s(_vm.diffHoursWithoutKidsForPeriod))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Med børn + Uden børn")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        animateFill: false,
        animation: 'shift-away',
        onShow: function () { return _vm.isDateIntervalChanged; }
      }),
      expression: "{\n          animateFill: false,\n          animation : 'shift-away',\n        onShow: () => isDateIntervalChanged\n      }"
    }],
    staticClass: "is-number",
    class: {
      'is-number--calculated': _vm.isDateIntervalChanged
    },
    attrs: {
      "content": _vm.tooltipContent
    }
  }, [(_vm.isDateIntervalChanged) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.assignedTotalHoursForPeriod) + "\n    ")]), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.userWithKidsAndWithout))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    style: (_vm.scaleIndicator(_vm.userDiffWithKidsAndWithout))
  }, [_vm._v("\n      " + _vm._s(_vm.userDiffWithKidsAndWithout) + "\n    ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('h4', [_vm._v("Oversigt")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-480c8896!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasksOverviewKindergarten.vue
// module id = 1896
// module chunks = 1